const makePalette = require('./palette')

exports.makePalette = makePalette
